/*
 * Copyright (C) 2025 Musarubra US LLC.  All Rights Reserved.
 */

import { WidgetContext } from './widget-context-base';
import { iamLogin } from '../main';
import { WidgetElements } from '../elements/widget-elements-base';
import { iam } from '../iam';

export class GenericWidgetContext extends WidgetContext {
  constructor(elements: WidgetElements) {
    super(elements);
  }

  public override initialize() {
    // login.html screen that doesn't need special screen-specific handling... just suck out the hidden okta title and subtitle,
    // put them in our sub-header elements, and show the widget's 'auth-footer' element for any links like "back to xxxx".
    // see getWidgetContextConfig() for which contexts use this, e.g. sms and call enrollment contexts.
    if (iam.settings.debug) console.log('initializing login widget generically');
    document.getElementById('dont-have-a-mvision').style.display = 'none';
    const oktaFormHead = this.elements.getFormHead();
    if (oktaFormHead) {
      document.getElementById('sub-header').textContent = oktaFormHead.textContent;
    }
    const oktaSubtitle = this.elements.getFormSubtitle();
    if (oktaSubtitle && oktaSubtitle.textContent) {
      document.getElementById('sub-header-2').textContent = oktaSubtitle.textContent;
      iamLogin.page.showCommonFields(['auth-footer', 'sub-header-2']);
    } else {
      iamLogin.page.showCommonFields(['auth-footer']);
    }
    iamLogin.page.initializeCommon();
  }

  public override get supported() {
    return false;
  }
}
